import { useState } from "react";
import { supabase } from "../supabaseClient";
import CreateProfileModal from "./CreateProfileModal";



function AuthPage({ onClose }) {

 const [email,setEmail] = useState("");
 const [password,setPassword] = useState("");
 const [signupOpen, setSignupOpen] = useState(false);
 const [rememberMe, setRememberMe] = useState(true);
 const [successMessage, setSuccessMessage] = useState("");


const signIn = async () => {

  const { data, error } = await supabase.auth.signInWithPassword({
    email,
    password
  });

  if (error) {
    alert(error.message);
    return;
  }

  if (!rememberMe) {
    sessionStorage.setItem(
      "supabase.auth.token",
      JSON.stringify(data.session)
    );

    localStorage.removeItem("supabase.auth.token");
  }

  // success feedback
 setSuccessMessage("Logged in successfully");

  // small delay allows auth state to update first
  setTimeout(() => {
    onClose();
  }, 300);

};
  

return (
<div style={containerStyle}>
  <div style={cardStyle}>
    <button style={closeButton} onClick={onClose}>
      ✕
    </button>
     <div style={{padding:"40px"}}>

      <h2>Create an Account or Log In to Get Started With Skate Spotter!</h2>

      <input
        placeholder="Email"
        required
        onChange={(e)=>setEmail(e.target.value)}
      />

      <br/><br/>

      <input
        type="password"
        placeholder="Password"
        required
        onChange={(e)=>setPassword(e.target.value)}
      />

    <label style={rememberStyle}>
      <input
        type="checkbox"
        checked={rememberMe}
        onChange={(e) => setRememberMe(e.target.checked)}
      />
      Remember Me
    </label>


   <br/><br/>

      {successMessage && (
        <p style={successStyle}>
          {successMessage}
        </p>
      )}
      
    <div style={buttonContainer}>

      <button
        style={loginButton}
        disabled={!email || !password}
        onClick={signIn}
      >
        Login
</button>

     <button style={createButton} onClick={() => setSignupOpen(true)}>
        Create Account
    </button>

    </div> 

    {signupOpen && (
        <CreateProfileModal
     onClose={()=>setSignupOpen(false)}
    />
    )}

    </div>
  </div>
</div>

  )
};
    

export default AuthPage;

const containerStyle = {
  position: "fixed",
  top:0,
  left:0,
  width:"100%",
  height:"100%",
  background:"rgba(0,0,0,0.75)",
  display:"flex",
  justifyContent:"center",
  alignItems:"center",
  zIndex: 20000,
};

const cardStyle = {
  background:"#1c1c1e",
  position: "relative",
  padding:"40px",
  borderRadius:"16px",
  width:"340px",
  textAlign:"center",
  color: "white",
};

const buttonContainer = {
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  marginTop: "24px"
};

const loginButton = {
  padding: "14px",
  borderRadius: "12px",
  border: "none",
  background: "#0a84ff",
  color: "white",
  fontWeight: "700",
  fontSize: "16px",
  cursor: "pointer"
};

const createButton = {
  padding: "14px",
  borderRadius: "12px",
  border: "none",
  background: "#3a3a3c",
  color: "white",
  fontWeight: "600",
  fontSize: "16px",
  cursor: "pointer"
};

const rememberStyle = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
  color: "#c7c7cc",
  fontSize: "14px",
  marginTop: "8px"
};

const closeButton = {
  position: "absolute",
  top: "16px",
  right: "16px",
  background: "transparent",
  border: "none",
  color: "white",
  fontSize: "20px",
  cursor: "pointer"
};

const successStyle = {
  color: "#30d158",
  fontWeight: "600",
  marginTop: "12px",
  marginBottom: "8px",
  textAlign: "center"
};